const attachReviewsToItems = (items, reviews) =>
  items.map((item) => {
    const itemToReturn = item;
    const productId = item._id; // api uses this for product id
    const matchingReview = reviews.find(review => review.product_id === productId);

    if (matchingReview) {
      itemToReturn.recommended = matchingReview.recommended;
      itemToReturn.rating = matchingReview.rating;
      itemToReturn.slug = matchingReview.slug;
      itemToReturn.reviewText = matchingReview.text;
      itemToReturn.reviewId = matchingReview._id;
      itemToReturn.published = matchingReview.published;
      itemToReturn.removed = matchingReview.removed;
      itemToReturn.hasActiveVersion = matchingReview.has_active_version;
    }

    return itemToReturn;
  });


export default attachReviewsToItems;
